import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {path: '/', name: 'Home', component: () => import('../views/Home.vue')},
  {path: '/tracking/:guia', name: 'Tracking', component: () => import('../views/_guia.vue')},
  {path: '/tracking/:guia/:token', name: 'Tracking', component: () => import('../views/_guia.vue')},
  {path: "*", redirect: "/" },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) =>  {  
  console.log("De: "+from.path+" - A: "+to.path)
  next()
})

export default router
